
import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex);
 
const state={//要设置的全局访问的state对象
	//要设置的初始属性值
    userId: '',
    token: '',
    nickname: '',
	bio: '',
	avatar: ''
};
const getters = {   //实时监听state值的变化(最新状态)
    getUserId(state) {  
       return state.userId
    },
    getToken(){  
       return state.token
    },
	getNickName(){  
	   return state.nickname
	},
	getBio(){  
	   return state.bio
	},
	getAvatar(){  
	   return state.avatar
	}
};
const mutations = {
    changeUserId(state, userId){ 
       state.userId = userId;
    },
	changeToken(state, token){
	   state.token = token;
	},
	changeNickName(state, nickname){
	   state.nickname = nickname;
	},
	changeBio(state, bio){
	   state.bio = bio;
	},
	changeAvatar(state, avatar){
	   state.avatar = avatar;
	}
};
const actions = {
    getUserId(context, userId){   //同上注释，userId为要变化的形参
        context.commit('changeUserId', userId)
    },
	getToken(context, token){   
	    context.commit('changeToken', token)
	},
	getNickName(context, nickname){   
	    context.commit('changeNickName', nickname)
	},
	getBio(context, bio){   
	    context.commit('changeBio', bio)
	},
	getAvatar(context, avatar){   
	    context.commit('changeAvatar', avatar)
	}
};
const store = new Vuex.Store({
	state,
	getters,
	mutations,
	actions	
});
 
export default store;


// WEBPACK FOOTER //
// ./src/store/store.js